import { Injectable } from '@angular/core';
import { CouponEntity, CouponItem, CouponCreate, CouponUpdate, CouponTarget, CategoryItem } from '@models';
import { BaseApi } from './_base-api';
import { DataGetOptions, ItemRecord, APIHelper } from '@controladad/ng-base';
import { map, Observable } from 'rxjs';
import { GetApiAdapter } from '../adapters';

@Injectable({
  providedIn: 'root',
})
export class CouponApiService extends BaseApi<CouponEntity, CouponCreate, CouponUpdate> {
  constructor() {
    super('/AdminPanel/Coupon', {
      get: 'GetCouponList',
      post: '/AdminPanel/CreateCoupon',
    });
  }

  // @ts-ignore
  override getAdapter(options?: DataGetOptions<CouponItem>) {
    return GetApiAdapter<CouponItem>('/AdminPanel/GetCouponList', options);
  }

  override get(id: number): Observable<CouponEntity> {
    return http$.get<CouponEntity>(`/AdminPanel/GetCoupon?CouponId=${id}`);
  }

  // Helper to transform targetIds to targetId for API
  private transformTargetsForApi(targets: CouponTarget[]) {
    return targets.map(target => ({
      targetType: target.targetType,
      targetIds: target.targetIds
    }));
  }

  // @ts-ignore
  override create(model: CouponCreate) {
    const apiModel = {
      fields: {
        ...model.fields,
        targets: this.transformTargetsForApi(model.fields.targets)
      }
    };
    return http$.post('/AdminPanel/CreateCoupon', apiModel);
  }

  // @ts-ignore
  override update(data: CouponUpdate) {
    const fieldsToUpdate = { ...data.fields };
    if (fieldsToUpdate.targets) {
      fieldsToUpdate.targets = this.transformTargetsForApi(fieldsToUpdate.targets) as any;
    }

    return http$.put('/AdminPanel/EditCoupon', {
      couponId: data.couponId,
      fields: APIHelper.nestValues(fieldsToUpdate)
    });
  }

  override delete(id: number | number[] | { id: number; } | { id: number; }[]): Observable<any> {
    return http$.delete('/AdminPanel/DeleteCoupons', { body: { couponIds: typeof id === 'number' ? [id] : id } });
  }

  getProductItems(): Observable<ItemRecord<number>[]> {
    return super
      .getAll<any>(undefined, '/AdminPanel/GetProductNames')
      .pipe(map((products) => products.map((v) => ({ value: v.id, label: v.name.english }))));
  }

  getVendorItems(): Observable<ItemRecord<number>[]> {
    return super
      .getAll<{ id: number; vendorName: string }>(undefined, '/AdminPanel/GetVendorList')
      .pipe(map((vendors) => vendors.map((v) => ({ label: `${v.id} - ${v.vendorName}`, value: v.id }))));
  }

  getCustomerItems(): Observable<ItemRecord<number>[]> {
    return super
      .getAll<any>(undefined, '/AdminPanel/GetCustomerList')
      .pipe(map((customers) => customers.map((c) => ({
        label: `${c.id} - ${c.email}`.trim(),
        value: c.id
      }))));
  }
}
